import { Component, OnInit } from '@angular/core';
import { Editor, toHTML } from 'ngx-editor';
import { Mmpi2Service } from 'src/app/services/mmpi2.service';

@Component({
  selector: 'app-mmpi2-combinations',
  templateUrl: './mmpi2-combinations.component.html',
  styleUrls: ['./mmpi2-combinations.component.css']
})
export class Mmpi2CombinationsComponent implements OnInit {

  public scales = [];
  public code1 = "";
  public code2 = "";
  public loadingScales = true;
  public editor:Editor;
  public html;
  public codes = [];
  public isEditing = false;
  public id;

  constructor(
    private mmpi2Service:Mmpi2Service
  ) { }

  ngOnInit(): void {
    this.editor = new Editor();
    this.mmpi2Service.getScales().subscribe(
      resp=>{
        this.loadingScales = false;
        let scalesArray = [];
        resp.all.map(
          scale=>{
            if(scale.type=='basicas') {
              if (scale.scale!='L'&&scale.scale!='?'&&scale.scale!='F'&&scale.scale!='K'&&scale.scale!='FB'&&scale.scale!='F(P)'&&scale.scale!='VRIN'&&scale.scale!='TRIN') scalesArray.push(scale)
            }       
          }
        )
        this.scales = scalesArray;
      },
      err=>console.log(err)
    )
    this.mmpi2Service.getCombinations().subscribe(
      resp=>{
        this.codes = resp;
      },
      err=>console.log(err)
    )
  }

  create(){
    var html;
    if (this.html.type == "doc"){
      html = toHTML(this.html);
    }else{
      html = this.html;
    }
    let obj = {
      code1:this.code1,
      code2:this.code2,
      text:html
    }
    this.mmpi2Service.createCombination(obj).subscribe(
      resp=>{
        location.reload();
      },
      err=>console.log(err)
    )
  }

  handleDelete(code, i){
    this.mmpi2Service.deleteCombination(code).subscribe(
      resp=>{
        this.codes.splice(i,1);
        this.html="";
      },
      err=>console.log(err)
    )
  }

  handleEdit(code){
    this.isEditing = true;
    this.html = code.text;
    this.code1 = code.code1;
    this.code2 = code.code2;
    this.id = code._id;
  }

  update(){
    var html;
    if (this.html.type == "doc"){
      html = toHTML(this.html);
    }else{
      html = this.html;
    }
    let obj = {
      code1:this.code1,
      code2:this.code2,
      text:html,
      _id:this.id
    }
    this.mmpi2Service.editCombination(obj).subscribe(
      resp=>{
        location.reload();
      },
      err=>console.log(err)
    )
  }

}
